/**
 * @generated SignedSource<<b0417dac99aa565c8b338e7f8157c32b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MarketingEmailDetailsView_query$data = {
  readonly emailLayouts: ReadonlyArray<{
    readonly emailLayoutIdentifier: string;
    readonly id: string;
    readonly isDefault: boolean;
    readonly name: string;
  }>;
  readonly " $fragmentType": "MarketingEmailDetailsView_query";
};
export type MarketingEmailDetailsView_query$key = {
  readonly " $data"?: MarketingEmailDetailsView_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"MarketingEmailDetailsView_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MarketingEmailDetailsView_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EmailLayout",
      "kind": "LinkedField",
      "name": "emailLayouts",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "emailLayoutIdentifier",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isDefault",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "606a00f8871e983d56a83c807592fbe7";

export default node;
